if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          const sync = () => requestAnimationFrame(() => this.syncFromMain());

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            sync();
          });

          const productRoot = document.querySelector(`.x-product-${sectionId}`);
          const mainPicker = productRoot?.querySelector('.variant-selects-main');
          if (mainPicker) {
            mainPicker.addEventListener('change', sync, true);
          }

          this.$nextTick(() => this.syncFromMain());
        },
        syncFromMain() {
          const productRoot = document.querySelector(`.x-product-${sectionId}`);
          const mainPicker = productRoot?.querySelector('.variant-selects-main');
          const container = document.getElementById(`variant-update-sticky-${sectionId}`);
          if (!mainPicker || !container) return;

          container.querySelectorAll('select').forEach((sel) => {
            const idx = sel.id.replace(`Option-sticky-${sectionId}-`, '');
            const fieldset = mainPicker.querySelector(`fieldset[data-option-index="${idx}"]`);
            let val = null;
            if (fieldset) {
              const radio = fieldset.querySelector('input[type="radio"]:checked');
              if (radio?.value) val = radio.value;
            }
            if (!val) {
              const mainSel = mainPicker.querySelector(`#Option-${sectionId}-${idx}`);
              if (mainSel?.value) val = mainSel.value;
            }
            if (!val) return;
            if (!Array.from(sel.options).some((o) => o.value === val)) return;
            sel.value = val;
          });

          const mainVarInput = document.getElementById(`update-variant-${sectionId}`);
          const stickyVarInput = document.getElementById(`update-variant-sticky-${sectionId}`);
          if (mainVarInput?.value && stickyVarInput) stickyVarInput.value = mainVarInput.value;

          const mainPrice = document.getElementById(`price-${sectionId}`);
          if (mainPrice) {
            document.querySelectorAll(`.price-sticky-${sectionId}`).forEach((d) => {
              d.innerHTML = mainPrice.innerHTML;
            });
          }

          const lampSel = container.querySelector('select[data-sticky-lamp-select]');
          const lampOpt = lampSel?.selectedOptions?.[0];
          if (lampOpt?.dataset?.previewImage) {
            const img = document.getElementById(`product-image-sticky-${sectionId}`)?.querySelector('img');
            if (img) img.src = lampOpt.dataset.previewImage;
          }
        },
        changeOptionSticky(event) {
          const sel = event.target;
          const chosen = sel.selectedOptions[0];
          const idx = sel.id.replace(`Option-sticky-${sectionId}-`, '');

          if (sel.dataset.stickyLampSelect && chosen?.dataset?.previewImage) {
            const img = document.getElementById(`product-image-sticky-${sectionId}`)?.querySelector('img');
            if (img) img.src = chosen.dataset.previewImage;
          }

          const productRoot = document.querySelector(`.x-product-${sectionId}`);
          const mainPicker = productRoot?.querySelector('.variant-selects-main');
          if (mainPicker) {
            const fieldset = mainPicker.querySelector(`fieldset[data-option-index="${idx}"]`);
            if (fieldset) {
              const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
                (inp) => inp.value === chosen.value
              );
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
            }
            const mainSel = mainPicker.querySelector(`#Option-${sectionId}-${idx}`);
            if (mainSel) {
              mainSel.value = chosen.value;
              mainSel.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }

          const variantEl = document.getElementById(`variant-update-sticky-${sectionId}`);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: { targetUrl: chosen?.dataset?.productUrl, variantElSticky: variantEl }
          }));
        },
        renderProductPrice(html) {
          document.querySelectorAll(`.price-sticky-${sectionId}`).forEach((d) => {
            const s = html.getElementById('price-sticky-' + sectionId);
            if (s && d) d.innerHTML = s.innerHTML;
          });
        },
        renderMedia(html) {
          const d = document.getElementById('product-image-sticky-' + sectionId);
          const s = html.getElementById('product-image-sticky-' + sectionId);
          if (s && d) d.innerHTML = s.innerHTML;
        }
      }));
    });
  });
}
